import { AxiosInstance } from 'axios';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { Range } from 'react-date-range';
import GlobalStore from './GlobalStore';
import PortfolioModel from '../Models/PortfolioModel';

export default class PortfolioStore {
    constructor(globalStore: GlobalStore) {
        this.axios = globalStore.axios;
        this.globalStore = globalStore;

        makeObservable(this, {
            model: observable,
            microCreds: observable,
            initialised: observable,
            dateRange: observable,
            getExperiences: observable,
            selectAllExperiences: action
        });
    }

    readonly globalStore: GlobalStore;

    axios: AxiosInstance;

    model?: PortfolioModel[];

    microCreds?: string[];

    initialised = false;

    dateRange?: Range[];

    getExperiences = () => {
        const start = this.dateRange![0].startDate!;
        const end = this.dateRange![0].endDate!;
        return this.model?.filter(exp => (
            new Date(exp.startDate) >= start
            && new Date(exp.endDate) <= end
        ));
    };

    selectAllExperiences = () => {
        // sort all experiences by start to get earliest start date
        const startExps = this.model?.sort((a, b) => (a.startDate > b.startDate ? 1 : -1));
        if (startExps) {
            this.dateRange![0].startDate = new Date(startExps[0].startDate);
        }

        // sort all experiences by end to get latest end date
        const endExps = this.model?.sort((a, b) => (a.endDate > b.endDate ? -1 : 1));
        if (endExps) {
            this.dateRange![0].endDate = new Date(endExps[0].endDate);
        }
    };

    initialiseAsync = async () => {
        if (this.initialised) {
            return;
        }
        runInAction(() => {
            this.initialised = true;
        });
        runInAction(() => {
            const today = new Date();
            const startDate = new Date(
                today.getFullYear(),
                today.getMonth() - 1,
                1
            );
            this.dateRange = [{
                startDate,
                endDate: today,
                key: 'selection'
            }];
        });

        (async () => {
            const model = await this.axios.get<PortfolioModel[]>('/api/portfolio');
            runInAction(() => {
                this.model = model.data;
            });
        })().catch(() => {
            this.globalStore.hasError = true;
        });

        (async () => {
            const microCreds = await this.axios.get<string[]>('/api/portfolio/microcreds');
            runInAction(() => {
                this.microCreds = microCreds.data;
            });
        })().catch(() => {
            this.globalStore.hasError = true;
        });
    };
}
